import { AccountBillingHostoryComponent } from './../account-billing-hostory/account-billing-hostory.component';
import { AddNewPaymentOptionComponent } from './../payment-options/add-new-payment-option/add-new-payment-option.component';
import { PaymentOptionsComponent } from './../payment-options/payment-options.component';
import { PaymentComponent } from './../payment.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BraintreeIntegrationComponent } from '../braintree-integration/braintree-integration.component';

const routes: Routes = [
  {
    path: '',
    component: PaymentComponent,
    children: [
      {
        path: '',
        component: PaymentOptionsComponent,
      },
     
      {
        path: 'addNewPayment',
        component: AddNewPaymentOptionComponent,
        
      },
      {
        path: 'accountBillingHistory',
        component: AccountBillingHostoryComponent,
      },
      {
        path: 'braintreeDropIn',
        component: BraintreeIntegrationComponent,
      },
       
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PaymentRoutingRoutingModule {}
